import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SampleUploader = _resolveComponent("SampleUploader")
  const _component_FilesUploader = _resolveComponent("FilesUploader")
  const _component_AvatarUploader = _resolveComponent("AvatarUploader")

  return ($props.mode === 'inline-text')
    ? (_openBlock(), _createBlock(_component_SampleUploader, {
        key: 0,
        accept: $props.accept,
        "store-type": $props.storeType,
        "max-uploads": $props.maxUploads,
        "max-size": $props.maxSize,
        "store-tag": $props.storeTag,
        "txt-rows": $props.txtRows,
        "file-rows": $props.fileRows,
        onUploaded: $options.handleUpload,
        onRemoved: $options.handleRemove
      }, null, 8 /* PROPS */, ["accept", "store-type", "max-uploads", "max-size", "store-tag", "txt-rows", "file-rows", "onUploaded", "onRemoved"]))
    : ($props.mode === 'files')
      ? (_openBlock(), _createBlock(_component_FilesUploader, {
          key: 1,
          "max-size": $props.maxSize,
          accept: $props.accept,
          "store-type": $props.storeType,
          "store-tag": $props.storeTag,
          "txt-rows": $props.txtRows,
          "file-rows": $props.fileRows,
          onUploaded: $options.handleUpload,
          onRemoved: $options.handleRemove
        }, null, 8 /* PROPS */, ["max-size", "accept", "store-type", "store-tag", "txt-rows", "file-rows", "onUploaded", "onRemoved"]))
      : ($props.mode === 'avatar')
        ? (_openBlock(), _createBlock(_component_AvatarUploader, {
            key: 2,
            "max-size": $props.maxSize,
            accept: $props.accept,
            "store-type": $props.storeType,
            "store-tag": $props.storeTag,
            "txt-rows": $props.txtRows,
            "file-rows": $props.fileRows,
            onUploaded: $options.handleUpload,
            onRemoved: $options.handleRemove
          }, null, 8 /* PROPS */, ["max-size", "accept", "store-type", "store-tag", "txt-rows", "file-rows", "onUploaded", "onRemoved"]))
        : _createCommentVNode("v-if", true)
}